/**
 * PCM Contact Form Feedback Toggle
 *
 * Shows/hides the "call info" block on the contact form based on the
 * `#contact_2_feedback` checkbox, running once on load to match whatever
 * the checkbox's initial state is.
 */
(function($) {
  'use strict';

  function initContactFeedbackToggle() {
    $('#contact_2_feedback').on('change.pcmLegacyContactFeedback', function() {
      $('.contact-us-form__callinfo').toggle(!!this.checked);
    }).triggerHandler('change.pcmLegacyContactFeedback');
  }

  if ($ && $.fn) {
    $(initContactFeedbackToggle);
  }
})(window.jQuery);
